import numeral from 'numeral';

export default {
    methods: {
        /**
         * @param  {String} isoDate
         * @return {String}
         */
        receiptDateFormat(isoDate) {
            return moment(isoDate).format('DD/MM/YYYY hh:mm A');
        },

        /**
         * @param  {Object} receipt
         * @return {String}
         */
        receiptNumberFormat(receipt) {
            let ids = [
                receipt.sequence_number,
                receipt.receipt_number.substr(0, 6),
            ];

            return ids.filter(s => s != null).join('/');
        },

        /**
         * @param  {Object} orderProduct
         * @return {String}
         */
        orderProductName(orderProduct) {
            if (orderProduct.variant !== null)
                return `${orderProduct.name} (${orderProduct.variant.name})`;

            return orderProduct.name;
        },

        /**
         * @param  {Object} orderProduct
         * @return {Float}
         */
        orderProductPrice(orderProduct) {
            let productPrice = 0;
            let actual;

            if (!_.isNull(orderProduct.variable_price)) {
                productPrice = orderProduct.variable_price;
            }

            if (!_.isNull(orderProduct.variant_price)) {
                productPrice = orderProduct.variant_price;
            }

            if (!_.isNull(orderProduct.unit_price)) {
                productPrice = orderProduct.unit_price;
            }

            actual = productPrice * orderProduct.quantity;

            return numeral(actual).format('0,0.00');
        },

        /**
         * @param  {Object} modifier
         * @param  {Object} orderProduct
         * @return {String}
         */
        orderProductModifierName(modifier) {
            if (modifier.modifier_id != null) return modifier.modifier.name;

            return modifier.name;
        },

        /**
         * @param  {Object} modifier
         * @param  {Object} orderProduct
         * @return {Float}
         */
        orderProductModifierPrice(modifier, orderProduct) {
            let orderModifier;
            let amount;
            let totalAmount;
            const productQty = orderProduct.quantity;
            const actualModifierQty = modifier.quantity * orderProduct.quantity;

            // get modifier mode from modifier record
            if (modifier.modifier_id != null) {
                orderModifier = modifier.modifier;
            } else {
                // get mode from custom modifier created in central
                orderModifier = modifier;
            }

            // multiply only if the mode is topup or deduct
            if (orderModifier.mode == 1 || orderModifier.mode == 2) {
                totalAmount = numeral(
                    modifier.amount * actualModifierQty,
                ).format();
            } else {
                totalAmount = modifier.amount;
            }

            switch (orderModifier.mode) {
                case 1:
                    // type topup
                    amount = '+ ' + totalAmount;
                    break;
                // type deduct
                case 2:
                    amount = '- ' + totalAmount;
                    break;
                // type discount
                case 3:
                    amount = `- ${numeral(totalAmount).format('0,0.[00]')}%`;
                    break;
                default:
                    // type instruction
                    amount = '0.00';
            }

            return amount;
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/receipt.js